const headers = {  
  'Content-Type': 'application/json'
};

// API 요청 기본 함수
const fetchAPI = async (endpoint, options = {}, _headers = headers) => {
  try {
    // 매 요청마다 최신 토큰을 가져오도록 헤더 업데이트
    const currentToken = localStorage.getItem('access_token');
    const updatedHeaders = {
      ..._headers,
      'Authorization': _headers.Authorization ? _headers.Authorization : `Bearer ${currentToken}`
    };

    // console.log('API Request:', {
    //   url: `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
    //   method: options.method,
    //   body: options.body
    // });   

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`, {
      ...options,
      headers: updatedHeaders
    });

    const data = await response.json();
    // console.log('API Response:', data);
    // console.log('response?.status', response?.status);

    if(response?.status === 200 || response?.status === 201) {
      return data;
    }else{
      throw new Error(data?.message || 'API request failed');
    }  

  } catch (error) {
    console.error('API Error:', {
      error: error.message,
      stack: error.stack,
      endpoint,
      options
    });
    throw error;
  }
};

// 바이너리(엑셀 등) — JSON 파싱 없이 Blob 반환
const fetchAPIBlob = async (endpoint) => {
  const currentToken = localStorage.getItem('access_token');
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${currentToken}`
    }
  });

  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    const ct = response.headers.get('content-type') || '';
    try {
      if (ct.includes('application/json')) {
        const errData = await response.json();
        message = errData?.message || errData?.error || message;
      } else {
        const text = await response.text();
        if (text) message = text.slice(0, 200);
      }
    } catch {
      /* use default message */
    }
    const err = new Error(message);
    console.error('API Error:', {
      error: err.message,
      stack: err.stack,
      endpoint
    });
    throw err;
  }

  return response.blob();
};

// 인증 API
export const authorizeAPI = {  
  // get access token ('password', 'sns', 'refresh_token')  
  signIn: async (authrizeData = {
    grant_type: null,         // grant type ( password , sns, refresh_token )
    // if grant_type is password,
    username: null, // login id
    password: null,       // login password
    // else if grant_type is sns,
    sns_type: null, // SNS provider type (kakao, naver, google, apple)
    sns_id: null, // SNS id
    // else
    refresh_token : null, // (optional) use if grant_type is 'refresh_token'
    // and next
    push_token: null,         // (optional) device token
  }) => {
    return await fetchAPI('/oauth/token', {
      method: 'POST',     
      body: JSON.stringify({
        ...authrizeData,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET
      })
    }, {'Content-Type': 'application/json'});
  },

  // revoke access token
  revokeAccessToken: async () => {    
    return await fetchAPI(`/oauth/revoke`, { 
      method: 'GET', 
      headers 
    });
  },
};

// 코드(모바일인증, 메일인증) API
export const codeAPI = {  
  // 코드 조회
  getCodes: async (params = {
    target: ''         // the code target(메일주소 혹은 휴대폰번호(현재 지원 안함))
  }) => {
    return await fetchAPI('/code/' + params.target, {
      method: 'GET',     
      body: JSON.stringify({      
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET
      })
    }, {'Content-Type': 'application/json'});
  },

  // 코드 발행
  codeGenerate: async (params = {
    target: null,          // the code target(메일주소 혹은 휴대폰번호(현재 지원 안함))
    type: null, // type (0:이메일 인증 1:모바일 인증)
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET
  }) => {
    return await fetchAPI('/code/generate', {
      method: 'POST',     
      body: JSON.stringify({
        ...params,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET
      })
    }, {'Content-Type': 'application/json'});
  },

  // 발행코드 확인
  codeConfirm: async (params = {
    target: null,          // the code target(메일주소 혹은 휴대폰번호(현재 지원 안함))
    type: null, // type (0:이메일 인증 1:모바일 인증)
    key: null, //the code key (인증번호)
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET
  }) => {
    return await fetchAPI('/code/confirm', {
      method: 'POST',     
      body: JSON.stringify({
        ...params,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET
      })
    }, {'Content-Type': 'application/json'});
  },
};

// 중계기 관련 API
export const commanderAPI = {

  // 중계기 목록 조회
  getCommanders: async (params = {
    id: null,          // 아이디 (',' 단위로 복수개 지원)
    hospitalId: null,  // 병원 아이디
    name: null,        // 이름
    uid: null,         // uid
    state: null,       // 상태 (0:등록, 1:삭제, 2:등록요청)
    offset: 0,         // first row index
    limit: 100        // row count
  }) => {
   
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== '') {
        queryParams.append(key, value);
      }
    });
    
    return await fetchAPI(`/commanders${queryParams ? `?${queryParams.toString()}` : ''}`, { 
      method: 'GET', 
      headers 
    });
  },

  // 중계기 수정
  updateCommander: async (commanderData = {
    id: null,         // 중계기 아이디
    hospitalId: null, // 병원 아이디
    name: null,       // 이름
    uid: null,        // uid
    state: 0,         // 상태 (0:등록, 1:삭제, 2:등록요청)
    os: null,         // os
    version: null,    // version
    deviceName: null      // device
  }) => {
    return await fetchAPI('/commander', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(commanderData)
    });
  },
  
  // 중계기 등록
  registerCommander: async (registerData = {
    hospitalId: null, // 병원 아이디
    name: null,       // 이름
    uid: null,        // uid
    state: 0,         // 상태 (0:등록, 1:삭제, 2:등록요청)
    os: null,         // os
    version: null,    // version
    deviceName: null      // device
  }) => {
    return await fetchAPI('/commander/register', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(registerData)
    });
  },

  // 중계기 등록 해제 (센서 연결도 해제)
  unregisterCommander: async (unregisterData = {
    id: null, // 중계기 아이디
  }) => {
    return await fetchAPI('/commander/unregister', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(unregisterData)
    });
  }
};

// 대시보드 관련 API
export const dashboardAPI = {
   // 대시보드 정보 조회
   getSupervisorDashboard: async (params = {
    maxLat: null, // maximum latitude
    maxLng: null, // maximum longitude
    minLat: null, // minimum latitude
    minLng: null, // minimum longitude
    country: null, // country
    region: null, // region
    hospitalId: null // hospital id    
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
      return await fetchAPI(`/supervisor-dashboard${queryString ? `?${queryString}` : ''}`);
    },

  // 대시보드 정보 조회
  getAdminDashboard: async (params = {
    date: null  // 일일데이터 조회날짜 (yyyy-mm-dd)
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/admin-dashboard${queryString ? `?${queryString}` : ''}`);
  }
};

// 기저귀 재고 관련 API
export const diaperStockAPI = {

  // 기저귀 재고 조회(supervisor 전용)
  getDiaperStocks: async (params = {
    startDate: null,   // 시작 날짜
    endDate: null,     // 종료 날짜      
    id: null,          // 기저귀 아이디
    hospitalId: null,  // 병원 아이디
    type: null,        // 타입 (0:판매, 1:회수, 2:보정)    
    offset: 0,         // first row index
    limit: 100        // row count
  }) => {   
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== '') {
        queryParams.append(key, value);
      }
    });
    
    return await fetchAPI(`/diaper-stocks${queryParams ? `?${queryParams.toString()}` : ''}`, { 
      method: 'GET', 
      headers 
    });
  },

   // 기저귀 재고 수정 (supervisor 전용)
   updateDiaperStock: async (diaperStockData = {    
  }) => {
    return await fetchAPI('/diaper-stock', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(diaperStockData)
    });
  },
  
  // 기저귀 재고 등록 (supervisor 전용)
  registerDiaperStock: async (diaperStockData = {      
  }) => {
    return await fetchAPI('/diaper-stock/register', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(diaperStockData)
    });
  }
};

// 기저귀 관련 API
export const diaperAPI = {

  // 기저귀 조회
  getDiapers: async (params = {
    startDate: null,   // 시작일
    endDate: null,     // 종료일      
    id: null,          // 아이디 (',' 단위로 복수개 지원)
    hospitalId: null,  // 병원 아이디
    userId: null,      // 유저 아이디
    managerId: null,   // 관리자 아이디
    type: null,        // 타입 (0:주간 기저귀, 1:야간 기저귀)
    state: null,       // 상태 (0:등록, 1:삭제)
    expand: null,      // 확장 조회 (user:유저,sensor:센서)    
    offset: 0,         // first row index
    limit: 100        // row count
  }) => {
   
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== '') {
        queryParams.append(key, value);
      }
    });
    
    return await fetchAPI(`/diapers${queryParams ? `?${queryParams.toString()}` : ''}`, { 
      method: 'GET', 
      headers 
    });
  },

  // 기저귀 로그 조회
  getDiaperLogs: async (params = {    
    id: null,          // 기저귀 아이디 (',' 단위로 복수개 지원)  
  }) => {   
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== '') {
        queryParams.append(key, value);
      }
    });
    
    return await fetchAPI(`/diaper-logs${queryParams ? `?${queryParams.toString()}` : ''}`, { 
      method: 'GET', 
      headers 
    });
  },

  // 기저귀 수정
  updateDiaper: async (diaperData = {
    id: null,         // 기저귀 아이디
    userId: null,     // 유저 아이디
    type: null,       // 타입 (0:주간 기저귀, 1:야간 기저귀)
    state: null,      // 상태 (0:등록, 1:삭제(교체))    
    excretionDate: null,    // 용변 및 야간모드 시작 시간  
    urineValue: null,    // 소변량 (0:없음, 1:소, 2:중, 3:대)
    urineColor: null,    // 소변색 (0:연함, 1:보통, 2:진함, 3:혈뇨)
    fecesValue: null,    // 대변량 (0:없음, 1:소, 2:중, 3:대)
    fecesType: null,    // 대변형태 (0:물설사, 1:설사, 2:보통, 3:단단함)
    fecesColor: null,    // 대변색 (0:연함, 1:보통, 2:진함, 3:혈변)
    changedCover: 0, // 커버 교체 여부 (0:교체 안함, 1:M 사이즈 교체, 2:L 사이즈 교체)
    info: null,         // 정보
    files: [],        // 이미지 파일. 최대 3개 (keep in last order.)    
  }) => {
    // 필수 필드 검증
    if (!diaperData.id) {
      throw new Error('id는 필수 필드입니다.');
    }

    // 파일 개수 검증
    if (diaperData.files && diaperData.files.length > 3) {
      throw new Error('파일은 최대 3개까지만 첨부 가능합니다.');
    }

    // multipart/form-data 형식으로 전송하기 위한 FormData 생성
    const formData = new FormData();
    
    // 파일을 제외한 데이터를 FormData에 추가
    Object.entries(diaperData).forEach(([key, value]) => {
      if (key !== 'files' && value !== null) {
        formData.append(key, value);
      }
    });

    // 파일들을 마지막에 추가
    // null이 아닌 실제 File 객체만 추가 (null은 파일 삭제를 의미하므로 파라미터를 보내지 않음)
    if (diaperData.files && diaperData.files.length > 0) {
      const validFiles = diaperData.files.filter(file => file !== null && file instanceof File);
      if (validFiles.length > 0) {
        validFiles.forEach((file, index) => {
          formData.append('files', file);
        });
      }
      // validFiles가 비어있으면 files 파라미터를 아예 보내지 않음 (파일 삭제)
    }

    return await fetchAPI('/diaper', {
      method: 'POST',     
      body: formData
    }, {
      // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
      // Authorization 헤더만 유지
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    });
  },
  
  // 기저귀 등록
  registerDiaper: async (diaperData = {
    userId: null,     // 유저 아이디
    type: null,       // 타입 (0:주간 기저귀, 1:야간 기저귀)
    changedCover: 0, // 커버 교체 여부 (0:교체 안함, 1:M 사이즈 교체, 2:L 사이즈 교체)
    info: null,       // 정보    
  }) => {
    return await fetchAPI('/diaper/register', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(diaperData)
    });
  }
};

// FAQ 관련 API
export const faqAPI = {
  // FAQ 목록 조회
  getFaqs: async (params = {
    id: null,         // 주제 아이디 
    category: null,   // 카테고리 (0:회원, 1:기사, 2:기타)
    state: null,      // 상태 (0:게시, 1:삭제, 2:비공개)
    keyword: null,    // 검색 키워드
    offset: 0,        // 시작 인덱스
    limit: 100        // 조회할 행 개수
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/faqs${queryString ? `?${queryString}` : ''}`);
  },

  // FAQ 수정
  updateFaq: async (faqData = {
    id: null,         // FAQ 아이디
    category: null,   // 카테고리 (0:회원, 1:기사, 2:기타)
    state: 0,         // 상태 (0:게시, 1:삭제, 2:비공개)
    question: null,   // FAQ 질문
    answer: null      // FAQ 답변
  }) => {
    return await fetchAPI('/faq', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(faqData)
    });
  },

  // FAQ 등록
  registerFaq: async (faqData = {
    category: null,   // 카테고리 (0:회원, 1:기사, 2:기타)
    state: 0,         // 상태 (0:게시, 1:삭제, 2:비공개)
    question: null,   // FAQ 질문
    answer: null      // FAQ 답변
  }) => {
    return await fetchAPI('/faq/register', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(faqData)
    });
  }
};

// 병원 관련 API
export const hospitalAPI = {
  // 병원 목록 조회
  getHospitals: async (params = {
    id: null,      // 병원 아이디
    userId: null,  // 유저 아이디
    name: null,     // 병원 이름
    state: null,    // 상태 (0:정상, 1:삭제)
    offset: 0,      // first row index, Default value : 0
    limit: 100      // row count, Default value : 100
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/hospitals${queryString ? `?${queryString}` : ''}`);
  },

  // 병원 수정
  updateHospital: async (hospitalData = {
    id: null,         // 병원 아이디
    userId: null,     // 유저 아이디
    name: null,       // 병원 이름
    state: 0,         // 상태 (0:정상, 1:삭제)
    address: null,    // 주소
    addressDetail: null, // 상세주소
    zipcode: null,     // 우편번호
    phone: null,      // 전화번호
    email: null,      // 이메일
    website: null,    // 웹사이트
    country: null,    // 국가 (ko:한국, ja:일본)
    region: null,     // 지역 (seoul:서울, jeju:제주, ...)
    latitude: null,   // 위도
    longitude: null,  // 경도
    info: null        // 정보
  }) => {
    return await fetchAPI('/hospital', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(hospitalData)
    });
  },

  // 병원 등록
  registerHospital: async (hospitalData = {
    userId: null,     // 유저 아이디
    name: null,       // 병원 이름
    address: null,    // 주소
    addressDetail: null, // 상세주소
    zipcode: null,     // 우편번호
    phone: null,      // 전화번호
    email: null,      // 이메일
    website: null,    // 웹사이트
    country: null,    // 국가 (ko:한국, ja:일본)
    region: null,     // 지역 (seoul:서울, jeju:제주, ...)
    latitude: null,   // 위도
    longitude: null,  // 경도
    info: null        // 정보
  }) => {
    return await fetchAPI('/hospital/register', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(hospitalData)
    });
  }
};

// 공지사항 관련 API
export const noticeAPI = {
  // 공지사항 목록 조회
  getNotices: async (params = {
    id: null,         // 아이디    
    hospitalId: null, // 병원 아이디 (',' 단위로 복수개 지원)
    state: null,      // 상태 (0:open, 1:delete, 2:reserve). (',' 단위로 복수개 지원)   
    keyword: null,    // 검색 키워드
    startDate: null,  // 게시일
    offset: 0,        // first row index, Default value : 0
    limit: 100        // row count, Default value : 100
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/notices${queryString ? `?${queryString}` : ''}`);
  },

  // 공지 수정 (관리자 전용)
  updateNotice: async (noticeData = {
    id: null,         // 공지 아이디
    type: null,       // 공지 타입 (0:시스템, 1:병원전체, 2:병원관리자, 3:병원사용자)
    hospitalId: null, // 병원 아이디
    state: 0,         // 공지 상태 (0:open, 1:delete, 2:reserve)
    startDate: null,  // 예약 게시일
    title: null,      // 공지 제목
    content: null,    // 공지 내용
    file: null,       // 공지 이미지 파일 경로 (keep in last order.)
  }) => {
    const formData = new FormData();
    Object.entries(noticeData).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    return await fetchAPI('/notice', {
      method: 'POST',
      body: formData     
      }, {
        // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
        // Authorization 헤더만 유지
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
      });
  },

  // 공지 등록 (관리자 전용)
  registerNotice: async (noticeData = {
    type: null,       // 공지 타입 (0:시스템, 1:병원전체, 2:병원관리자, 3:병원사용자)
    hospitalId: null, // 병원 아이디
    state: 0,         // 상태 (0:open, 1:delete, 2:reserve)
    startDate: null,  // 예약 게시일
    title: null,      // 공지 제목
    content: null,     // 공지 내용
    file: null,       // 공지 이미지 파일 경로 (keep in last order.)
  }) => {
    const formData = new FormData();
    Object.entries(noticeData).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    return await fetchAPI('/notice/register', {
      method: 'POST',
      body: formData     
      }, {
        // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
        // Authorization 헤더만 유지
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
      });
  }
};

// 공지알림 관련 API
export const notificationAPI = {
  // 공지알림 목록 조회
  getNotifications: async (params = {
    id: null,         // 아이디
    hospitalId: null, // 병원 아이디(0:all)
    userId: null,     // 대상 유저 아이디
    state: null,      // 상태 (0:게시, 1:삭제, 2:예약)
    startDate: null,  // 게시일
    offset: 0,        // first row index, Default value : 0
    limit: 100        // row count, Default value : 100
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/notifications${queryString ? `?${queryString}` : ''}`);
  },

  // 알림 수정 (관리자 전용)
  updateNotification: async (notificationData = {
    id: null,         // the notification id
    hospitalId: null, // 병원 아이디(0:all)
    userId: null,     // 대상 유저 아이디(0:all)
    type: 0,       // 알림 타입 (0:all, 1:매니저, 2:사용자, 3:nightMode(시스템 알림, 운영툴에서 사용 불가), 4:diaper(시스템 알림, 운영툴에서 사용 불가), 5:sensor(시스템 알림, 운영툴에서 사용 불가))
    state: 0,         // 상태 (0:open, 1:delete, 2:private, 3:reserve)
    startDate: null,  // 예약 게시일
    title: null,      // 알림 제목
    content: null     // 알림 내용
  }) => {
    return await fetchAPI('/notification', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(notificationData)
    });
  },

  // 알림 등록 (관리자 전용)
  registerNotification: async (notificationData = {
    hospitalId: null, // 병원 아이디(0:all)
    userId: null,     // 대상 유저 아이디(0:all)
    type: 0,         // 알림 타입 (0:all, 1:매니저, 2:사용자, 3:nightMode(시스템 알림, 운영툴에서 사용 불가), 4:diaper(시스템 알림, 운영툴에서 사용 불가), 5:sensor(시스템 알림, 운영툴에서 사용 불가))
    state: 0,         // 알림 상태 (0:open, 1:delete, 2:reserve)
    startDate: null,  // 예약 게시일    
    title: null,      // 알림 제목
    content: null     // 알림 내용
  }) => {
    return await fetchAPI('/notification/register', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(notificationData)
    });
  }
};

// 팝업 관련 API
export const popupAPI = {
  // 팝업 목록 조회
  getPopups: async (params = {
    id: null,         // 주제 아이디
    category: null,   // 카테고리 (0:텍스트, 1:이미지)
    state: null,      // 상태 (0:게시, 1:삭제, 2:비공개, 3:예약)
    status: null,     // 상태 (waiting:대기중, ongoing:진행중, finishing:완료)
    keyword: null,    // 검색 키워드
    startDate: null,  // 시작 게시일
    endDate: null,    // 종료 게시일
    offset: 0,        // 시작 인덱스
    limit: 100        // 조회할 행 개수
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/popups${queryString ? `?${queryString}` : ''}`);
  },

  // 팝업 수정
  updatePopup: async (popupData = {
    id: null,         // 팝업 아이디 (필수)
    state: 0,         // 상태 (0:open, 1:delete, 2:private, 3:reserve)
    startDate: null,  // 시작 게시일
    endDate: null,    // 종료 게시일
    subject: null,    // 팝업 제목
    category: null,   // 카테고리 (0:텍스트 1:이미지)
    title: null,      // 팝업 제목
    content: null,    // 팝업 내용
    href: null,       // 하이퍼링크
    file: null        // 이미지 파일 (binary)
  }) => {
    // multipart/form-data 형식으로 전송하기 위한 FormData 생성
    const formData = new FormData();
    
    // 파일을 제외한 데이터를 FormData에 추가
    Object.entries(popupData).forEach(([key, value]) => {
      if (key !== 'file' && value !== null) {
        formData.append(key, value);
      }
    });

    // 파일이 있는 경우 마지막에 추가
    if (popupData.file) {
      formData.append('file', popupData.file);
    }

    return await fetchAPI('/popup', {
      method: 'POST',      
      body: formData
    }, {
      // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
      // Authorization 헤더만 유지
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    });
  },

  // 팝업 등록
  registerPopup: async (popupData = {
    state: 0,         // 상태 (0:open, 1:delete, 2:private, 3:reserve)
    startDate: null,  // 시작 게시일
    endDate: null,    // 종료 게시일
    subject: null,    // 팝업 제목 (필수)
    category: null,   // 카테고리 (0:텍스트 1:이미지) (필수)
    title: null,      // 팝업 제목 (필수)
    content: null,    // 팝업 내용
    href: null,       // 하이퍼링크
    file: null        // 이미지 파일
  }) => {
    // 필수 필드 검증
    if (!popupData.subject || !popupData.category || !popupData.title) {
      throw new Error('필수 필드가 누락되었습니다 (subject, category, title)');
    }

    // multipart/form-data 형식으로 전송하기 위한 FormData 생성
    const formData = new FormData();
    
    // 파일을 제외한 데이터를 FormData에 추가
    Object.entries(popupData).forEach(([key, value]) => {
      if (key !== 'file' && value !== null) {
        formData.append(key, value);
      }
    });

    // 파일이 있는 경우 마지막에 추가
    if (popupData.file) {
      formData.append('file', popupData.file);
    }

    return await fetchAPI('/popup/register', {
      method: 'POST',      
      body: formData
    }, {
      // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
      // Authorization 헤더만 유지
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    });
  }
};

// QnA 관련 API
export const qnaAPI = {
  // QnA 목록 조회
  getQnas: async (params = {
    id: null,              // 아이디
    userId: null,          // 작성 유저 아이디
    category: null,        // 카테고리
    state: null,           // 상태 (0:게시, 1:삭제, 2:답변완료)
    keyword: null,         // 검색 키워드
    startCreateDate: null, // 시작 생성시간
    endCreateDate: null,   // 종료 생성시간
    offset: 0,            // 시작 인덱스
    limit: 100            // 조회할 행 개수
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/qnas${queryString ? `?${queryString}` : ''}`);
  },

  // QnA 수정
  updateQna: async (qnaData = {
    id: null,         // QnA 아이디 (필수)
    category: null,   // 카테고리 (0:매거진 1:미션 리워드 2:나의 포인트 3:신고/게시 중단 4:비지니스 5:기타)
    state: 0,         // 상태 (0:게시, 1:삭제, 2:답변완료)
    title: null,      // QnA 제목
    content: null,    // QnA 내용
    answer: null,     // QnA 답변
    files: []         // 이미지 파일 배열 (최대 5개)
  }) => {
    // 필수 필드 검증
    if (!qnaData.id) {
      throw new Error('id는 필수 필드입니다.');
    }

    // 파일 개수 검증
    if (qnaData.files && qnaData.files.length > 5) {
      throw new Error('파일은 최대 5개까지만 첨부 가능합니다.');
    }

    // multipart/form-data 형식으로 전송하기 위한 FormData 생성
    const formData = new FormData();
    
    // 파일을 제외한 데이터를 FormData에 추가
    Object.entries(qnaData).forEach(([key, value]) => {
      if (key !== 'files' && value !== null) {
        formData.append(key, value);
      }
    });

    // 파일들을 마지막에 추가
    if (qnaData.files && qnaData.files.length > 0) {
      qnaData.files.forEach((file, index) => {
        formData.append('files', file);
      });
    }

    return await fetchAPI('/qna', {
      method: 'POST',
      body: formData
    }, {
      // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
      // Authorization 헤더만 유지
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    });
  },

  // QnA 등록
  registerQna: async (qnaData = {
    category: null,   // 카테고리 (0:매거진 1:미션 리워드 2:나의 포인트 3:신고/게시 중단 4:비지니스 5:기타) (필수)
    title: null,      // QnA 제목 (필수)
    content: null,    // QnA 내용 (필수)
    files: []         // 이미지 파일 배열 (최대 5개)
  }) => {
    // 필수 필드 검증
    if (!qnaData.category || !qnaData.title || !qnaData.content) {
      throw new Error('category, title, content는 필수 필드입니다.');
    }

    // 파일 개수 검증
    if (qnaData.files && qnaData.files.length > 5) {
      throw new Error('파일은 최대 5개까지만 첨부 가능합니다.');
    }

    // multipart/form-data 형식으로 전송하기 위한 FormData 생성
    const formData = new FormData();
    
    // 파일을 제외한 데이터를 FormData에 추가
    Object.entries(qnaData).forEach(([key, value]) => {
      if (key !== 'files' && value !== null) {
        formData.append(key, value);
      }
    });

    // 파일들을 마지막에 추가
    if (qnaData.files && qnaData.files.length > 0) {
      qnaData.files.forEach((file, index) => {
        formData.append('files', file);
      });
    }

    return await fetchAPI('/qna/register', {
      method: 'POST',     
      body: formData
    }, {
      // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
      // Authorization 헤더만 유지
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    });
  }
};

// 관계(매니저, 가족) 관련 API
export const relationshipAPI = {
  // 관계 조회
  getRelationships: async (params = {    
    userId: null,     // 유저 아이디
    relatedUserId: null, // 관계 유저(환자) 아이디
    type: null, // 타입 (0:매니저, 1:가족)
    state: null,      // 상태 (0:정상, 1:삭제, 2:대기)
    expand: null, // 확장 조회 (user(유저), relatedUser(관계 유저)).    Available values : user, relatedUser, user,relatedUser 
    offset: 0        // 시작 인덱스    
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/relationships${queryString ? `?${queryString}` : ''}`);
  },

  // 관계 수정
  updateRelationship: async (relationshipData = {
    userId: null,     // 유저 아이디
    relatedUserId: null, // 관계 유저 아이디
    type: null, // 타입 (0:매니저, 1:가족)
    state: null, // 상태 (0:정상, 1:삭제, 2:대기)
    info: null, // 관계 정보    
  }) => {
    return await fetchAPI('/relationship', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(relationshipData)
    });
  },

  // 관계 등록
  registerRelationship: async (relationshipData = {
    userId: null,     // 유저 아이디
    relatedUserId: null, // 관계 유저 아이디
    type: null, // 타입 (0:매니저, 1:가족)
    state: null, // 상태 (0:정상, 1:삭제, 2:대기)
    info: null, // 관계 정보  
  }) => {
    return await fetchAPI('/relationship/register', {
      method: 'POST',
      headers,        // 기존 headers 사용
      body: JSON.stringify(relationshipData)
    });
  }
};

// 보고서(약,식사,수분 섭취 기록) 관련 API
export const reportAPI = {
  // 보고서 조회
  getReports: async (params = {
    startDate: null,
    endDate: null,
    userId: null,
    hospitalId: null,
    managerId: null,
    type: null,
    expand: null,
    offset: 0,
    limit: 100
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/reports${queryString ? `?${queryString}` : ''}`);
  },

  // 보고서 수정
  updateReport: async (reportData = {
    date: null,         // 날짜
    userId: null,   // 유저 아이디
    type: 0,         // 타입 (0:조식, 1:중식, 2:석식, 3:취짐전)
    mainFoodValue : null,      // 메인 음식 값
    subFoodValue : null,    // 서브 음식 값
    waterValue: null,     // 물 값
    medicineTime: null,        // 약 시간 (0:없음, 1:식전, 2:식후, 3:취짐전)
    info: null // 정보
  }) => {
   
    return await fetchAPI('/report', {
      method: 'POST',
      headers,
      body: JSON.stringify(reportData)
    });
  },

  // 보고서 등록
  registerReport: async (reportData = {
    date: null,         // 날짜
    userId: null,   // 유저 아이디
    managerId: null,
    type: 0,         // 타입  (0:조식, 1:중식, 2:석식, 3:취짐전)
    mainFoodValue : null,      // 메인 음식 값
    subFoodValue : null,    // 서브 음식 값
    waterValue: null,     // 물 값
    medicineTime: null,        // 약 시간 (0:없음, 1:식전, 2:식후, 3:취짐전)
    info: null // 정보
  }) => {
    return await fetchAPI('/report/register', {
      method: 'POST',
      headers,
      body: JSON.stringify(reportData)
    });
  }
};

// 스케줄 관련 API
export const scheduleAPI = {

  // 스케줄 댓글 목록 조회
  getScheduleComments: async (params = {
    id: null,         // 댓글 아이디
    scheduleId: null, // 스케줄 아이디
    userId: null,     // 작성 유저 아이디
    state: null,      // 상태 (0:공개, 1:삭제)
    keyword: null,    // 검색 키워드
    offset: 0,        // 시작 인덱스
    limit: 100        // 조회할 행 개수
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/schedule-comments${queryString ? `?${queryString}` : ''}`);
  },

   // 스케줄 댓글 수정
   updateScheduleComment: async (commentData = {
    id: null,         // 아이디
    scheduleId: null, // 스케줄 아이디
    state: 0,         // 상태 (0:생성, 1:삭제)
    content: null     // 내용
  }) => {
    return await fetchAPI('/schedule-comment', {
      method: 'POST',
      headers,
      body: JSON.stringify(commentData)
    });
  },

  // 스케줄 댓글 등록
  registerScheduleComment: async (commentData = {
    scheduleId: null,  // 스케줄 아이디
    commentId: null,   // 대댓글 commentId
    content: null      // 내용
  }) => {
    return await fetchAPI('/schedule-comment/register', {
      method: 'POST',
      headers,
      body: JSON.stringify(commentData)
    });
  },

  // 스케줄 플래그 수정
  updateScheduleFlag: async (flagData = {
    scheduleId: null,  // 스케줄 아이디
    commentId: null,   // 본문글 0 혹은 댓글 아이디
    state: 0,         // 상태 (0:생성, 1:삭제)
    type: null        // 타입 (0:좋아요, 1:저장)
  }) => {
    return await fetchAPI('/schedule-flag', {
      method: 'POST',
      headers,
      body: JSON.stringify(flagData)
    });
  },

   // 스케줄 플래그 등록
   registerScheduleFlag: async (flagData = {
    scheduleId: null,  // 스케줄 아이디
    commentId: null,   // 본문글 0 혹은 댓글 아이디
    type: null        // 타입 (0:좋아요, 1:저장)
  }) => {
    return await fetchAPI('/schedule-flag/register', {
      method: 'POST',
      headers,
      body: JSON.stringify(flagData)
    });
  },

  // 스케줄 목록 조회
  getSchedules: async (params = {
    id: null,         // 아이디
    userId: null,     // 작성 유저 아이디
    category: null,   // 카테고리
    state: null,      // 상태 (0:게시, 1:삭제, 2:비공개, 3:예약, 4:등록신청, 5:거절)
    status: null,     // 상태 (waiting:대기중, ongoing:진행중)
    officialId: null, // 공식계정 아이디
    keyword: null,    // 검색 키워드
    startDate: null,  // 게시일
    startTime: null,  // 시작시간
    endTime: null,    // 종료시간
    offset: 0,        // 시작 인덱스
    limit: 100        // 조회할 행 개수
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/schedules${queryString ? `?${queryString}` : ''}`);
  },

  // 스케줄 수정
  updateSchedule: async (scheduleData = {
    id: null,         // 스케줄 아이디 (필수)
    state: 0,         // 상태 (0:게시, 1:삭제, 2:비공개, 3:예약, 4:등록신청, 5:거절)
    startDate: null,  // 예약 게시일
    category: null,   // 카테고리
    schoolId: null,   // 학교 아이디
    officialId: null, // 공식계정 아이디
    startTime: null,  // 시작시간
    endTime: null,    // 종료시간
    isAllDate: 0,     // 하루종일
    title: null,      // 스케줄 제목
    content: null,    // 스케줄 내용
    moreUrl: null,    // 추가 링크
    reason: null,     // 신청 및 거절 이유
    file: null        // 이미지 파일
  }) => {
    // 필수 필드 검증
    if (!scheduleData.id) {
      throw new Error('id는 필수 필드입니다.');
    }

    // multipart/form-data 형식으로 전송하기 위한 FormData 생성
    const formData = new FormData();
    
    // 파일을 제외한 데이터를 FormData에 추가
    Object.entries(scheduleData).forEach(([key, value]) => {
      if (key !== 'file' && value !== null) {
        formData.append(key, value);
      }
    });

    // 파일이 있는 경우 마지막에 추가
    if (scheduleData.file) {
      formData.append('file', scheduleData.file);
    }

    return await fetchAPI('/schedule', {
      method: 'POST',      
      body: formData
    }, {
      // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
      // Authorization 헤더만 유지
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    });
  },

  // 스케줄 등록
  registerSchedule: async (scheduleData = {
    state: null,      // 상태 (0:게시, 1:삭제, 2:비공개, 3:예약, 4:등록신청, 5:거절) (필수)
    startDate: null,  // 예약 게시일
    category: null,   // 카테고리
    schoolId: null,   // 학교 아이디
    officialId: null, // 공식계정 아이디
    startTime: null,  // 시작시간 (필수)
    endTime: null,    // 종료시간
    isAllDate: false, // 하루종일 (0:false, 1:true)
    title: null,      // 스케줄 제목 (필수)
    content: null,    // 스케줄 내용 (필수)
    moreUrl: null,    // 추가 링크
    file: null        // 이미지 파일
  }) => {
    // 필수 필드 검증
    if (!scheduleData.state || !scheduleData.category || !scheduleData.startTime || 
        !scheduleData.title || !scheduleData.content) {
      throw new Error('state, category, startTime, title, content는 필수 필드입니다.');
    }

    // multipart/form-data 형식으로 전송하기 위한 FormData 생성
    const formData = new FormData();
    
    // 파일을 제외한 데이터를 FormData에 추가
    Object.entries(scheduleData).forEach(([key, value]) => {
      if (key !== 'file' && value !== null) {
        formData.append(key, typeof value === 'boolean' ? (value ? '1' : '0') : value);
      }
    });

    // 파일이 있는 경우 마지막에 추가
    if (scheduleData.file) {
      formData.append('file', scheduleData.file);
    }

    return await fetchAPI('/schedule/register', {
      method: 'POST',
      body: formData
    }, {
      // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
      // Authorization 헤더만 유지
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    });
  }
};

// 센서 데이터 관련 API
export const sensorDataAPI = {
  // 센서 데이터 목록 조회
  getSensorData: async (params = {    
    startDate: null, // 시작 기간
    endDate: null,   // 종료 기간
    id: null,              // 아이디(',' 단위로 복수개 지원)
    event: null,           // 이벤트 (0:정상 동작, 1:기저귀 교체 필요, 2:기저귀 교체 완료, 3:배터리 체크)
    offset: 0,             // first row index
    limit: 100             // row count
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/sensor-data${queryString ? `?${queryString}` : ''}`);
  },

  // 센서 데이터 엑셀 다운로드
  downloadSensorDataExcel: async (params = {
    startDate: null, // 시작 기간
    endDate: null,   // 종료 기간
    id: null,              // 아이디(',' 단위로 복수개 지원)
    event: null,           // 이벤트 (0:정상 동작, 1:기저귀 교체 필요, 2:기저귀 교체 완료, 3:배터리 체크 4:동작 확인)
    hospitalName: null,    // 병원 이름
    loginId: null,         // 로그인 ID
    name: null,            // 사용자 이름
    offset: 0,             // first row index
    limit: 0               // row count. 0 is all
  }) => {

    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPIBlob(`/sensor-data/excel${queryString ? `?${queryString}` : ''}`);
  },
  // 센서 데이터 등록
  registerSensorData: async (sensorData = {
    id: null,           // 센서 아이디
    battery: null,      // 배터리
    sensitive: null,    // 민감도 (0:none, 1:high, 2:medium, 3:low)
    alertType: null,    // 알림 유형 (0:none, 1:only led, 2:both led and buzzer)
    alert: null,        // 알림 (0:none, 1:working, 2:urine, 3:feces)
    sensorCount: null,  // 센서 개수
    sensorData: []      // 센서 데이터 배열
  }) => {
    return await fetchAPI('/sensor-data/register', {
      method: 'POST',
      headers,
      body: JSON.stringify(sensorData)
    });
  }
};

// 센서 관련 API
export const sensorAPI = {
  // 센서 목록 조회
  getSensors: async (params = {
    id: null,          // 아이디
    hospitalId: null,  // 병원 아이디
    commanderId: null, // 중계기 아이디, 0일 경우 등록된 중계기 없음
    userId: null,
    name: null,        // 이름
    uid: null,         // uid
    state: null,       // 상태 (0:등록, 1:삭제, 2:휴면)
    offset: 0,         // 시작 인덱스
    limit: 100         // 조회할 행 개수
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/sensors${queryString ? `?${queryString}` : ''}`);
  },

  // 센서 수정
  updateSensor: async (sensorData = {
    id: null,           // 센서 아이디
    hospitalId: null,   // 병원 아이디
    commanderId: null,  // 중계기 아이디
    orderIndex: null,   // 순서
    userId: null,       // 유저 아이디
    name: null,         // 이름
    uid: null,          // uid   
    state: 0            // 상태 (0:등록, 1:삭제, 2:휴면)
  }) => {
    return await fetchAPI('/sensor', {
      method: 'POST',
      headers,
      body: JSON.stringify(sensorData)
    });
  },

  // 센서 등록
  registerSensor: async (sensorData = {
    hospitalId: null,   // 병원 아이디  
    // commanderId: 0,  // 중계기 아이디 // 기본값 제거
    orderIndex: 0,      // 순서
    userId: 0,          // 유저 아이디
    name: null,         // 이름
    uid: null,          // uid
    state: 0            // 상태 (0:등록, 1:삭제, 2:휴면)
  }) => {
    // undefined/null 값은 body에서 제거
    const cleanData = {};
    Object.entries(sensorData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        cleanData[key] = value;
      }
    });

    return await fetchAPI('/sensor/register', {
      method: 'POST',
      headers,
      body: JSON.stringify(cleanData)
    });
  }
};

// 사용자 세팅 관련 API
export const settingAPI = {
  // 사용자 세팅 조회
  getSettings: async (params = {    
    appId: null, // 앱 아이디
    userId: null,  // 사용자 아이디    
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/settings${queryString ? `?${queryString}` : ''}`);
  },

  // 사용자 세팅 수정
  updateSetting: async (settingData = {      
    name: null,         // 세팅 이름
    value: null,        // 세팅 값
    state: null,        // 세팅 상태 (0:사용, 1:미사용)    
  }) => {
    return await fetchAPI('/setting', {
      method: 'POST',
      headers,
      body: JSON.stringify(settingData)
    });
  },

  // 사용자 세팅 등록
  registerSetting: async (settingData = {   
    name: null,         // 세팅 이름
    value: null,        // 세팅 값
  }) => {
    return await fetchAPI('/setting/register', {
      method: 'POST',
      headers,
      body: JSON.stringify(settingData)
    });
  }
};

// 시스템 컨피그 관련 API
export const sysconfigAPI = {
  // 시스템 컨피그 조회
  getSysconfigs: async (params = {    
    hospitalId: null,  // 병원 아이디    
  }) => {
    const queryString = new URLSearchParams(
      Object.entries(params)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    ).toString();
    
    return await fetchAPI(`/sysconfigs${queryString ? `?${queryString}` : ''}`);
  },

  // 시스템 컨피그 수정
  updateSysconfig: async (sysconfigData = {    
    hospitalId: null,   // 병원 아이디
    name: null,         // 컨피그 이름
    value: null,        // 컨피그 값
    state: null,        // 상태 (0:사용, 1:미사용)    
  }) => {
    return await fetchAPI('/sysconfig', {
      method: 'POST',
      headers,
      body: JSON.stringify(sysconfigData)
    });
  },

  // 시스템 컨피그 등록
  registerSysconfig: async (sysconfigData = {
    hospitalId: null,   // 병원 아이디
    name: null,         // 컨피그 이름
    value: null,        // 컨피그 값
  }) => {
    return await fetchAPI('/sysconfig/register', {
      method: 'POST',
      headers,
      body: JSON.stringify(sysconfigData)
    });
  }
};

// 유저 정보 관련 API 함수들
export const userAPI = {
  // 유저 조회
  getUserMe: async (accessToken = null) => {
    return await fetchAPI(`/users/me`, {
      method: 'GET',
      headers
    },
    accessToken ? {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    } : headers);   
  },

  // 사용자 목록 조회 (관리자/운영자 전용)
  getUsers: async (params = {
    userId: 'all',     // 사용자 ID (필수, 'all'인 경우 전체 조회)
    loginId: null,     // 로그인 ID
    grade: null,       // 등급 (콤마로 구분된 다중 값 가능)
    state: null,       // 상태 (0:open, 1:delete, 2:block, 콤마로 구분된 다중 값 가능)
    name: null,        // 사용자 이름
    nickname: null,    // 닉네임
    birth: null,       // 생년월일 (yyyy-mm-dd)
    gender: null,      // 성별 (0:male, 1:female)
    email: null,       // 이메일
    mobile: null,      // 휴대전화
    hospitalId: null,  // 병원 ID
    roomInfo: null,    // 병실 정보
    roomInfoKeyword: null, // 병실(그룹) 검색 키워드
    keyword: null,     // 검색 키워드
    offset: 0,         // 조회 시작 인덱스
    limit: 100         // 조회 개수
  }) => {
    // userId 필수 체크
    if (!params.userId) {
      throw new Error('userId는 필수 파라미터입니다.');
    }

    // userId를 URL에 포함
    const userId = params.userId;
    delete params.userId;

    // 쿼리 파라미터 구성
    const queryParams = new URLSearchParams();
    
    // 모든 파라미터를 순회하면서 null이 아닌 값만 추가
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== '') {
        queryParams.append(key, value);
      }
    });

    return await fetchAPI(`/users/${userId}?${queryParams.toString()}`, {
      method: 'GET',
      headers
    });
  },

  // 사용자 존재 여부 확인
  checkUserExists: async (userData = {
    loginId: null,      // login id로 확인
    nickname: null,     // nickname으로 확인
    email: null,        // email로 확인
  }) => {
    // 요청 데이터 준비
    const requestData = {
      ...userData,
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET
    };

    return await fetchAPI('/user/exists', {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData)
    });
  },

  // 아이디 찾기
  findUserId: async (userData = {
    name: '',           // 사용자 이름
    birth: '',         // 생년월일
  }) => {
    // 필수 필드 확인
    if (!userData.name || !userData.birth) {
      throw new Error('이름과 생년월일은 필수 입력 항목입니다.');
    }

    const requestData = {
      ...userData,
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET
    };

    return await fetchAPI('/user/find-id', {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData)
    });
  },

  // 패스워드 찾기 (임시 패스워드 발급))
  findPassword: async (userData = {
    loginId: '',        // 로그인 ID    
  }) => {
    // 필수 필드 확인
    if (!userData.loginId) {
      throw new Error('로그인 ID는 필수 입력 항목입니다.');
    }

    const requestData = {
      ...userData,
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET
    };

    return await fetchAPI('/user/find-password', {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData)
    });
  },  

  // 회원가입 시 프로파일 이미지 설정
  initProfileImage: async (userData = {
    loginId: '',        // 로그인 ID (필수)
    name: '',           // 사용자 이름 (필수)
    file: null         // 프로필 이미지 파일 (필수)
  }) => {
    // 필수 필드 확인
    if (!userData.loginId || !userData.name || !userData.file) {
      throw new Error('모든 필드는 필수 입력 항목입니다.');
    }

    // FormData 객체 생성
    const formData = new FormData();
    formData.append('loginId', userData.loginId);
    formData.append('name', userData.name);
    formData.append('client_id', process.env.REACT_APP_CLIENT_ID);
    formData.append('client_secret', process.env.REACT_APP_CLIENT_SECRET);
    formData.append('file', userData.file);

    return await fetchAPI('/user/init-profile-image', {
      method: 'POST',      
      body: formData
    }, {
      // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
      // Authorization 헤더만 유지
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    });
  },

  // 유저 수정
  updateUser: async (userData = {
    id: '',               // the user id
    name: '',             // name
    nickname: '',         // nickname
    birth: '',            // birthday
    gender: 0,            // gender (0:male, 1:female)
    email: '',            // e-mail
    mobile: '',           // 휴대전화
    hospitalId: null,     // 병원 아이디
    roomInfo: '',         // 방 정보
    floor: '',            // 층
    careGrade: '',        // 케어 등급 (0:none, 1(1level) ~ 100(100level))
    isWaterCare: null,    // 물 케어 여부 (0:미사용, 1:사용)
    isMedicineCare: null, // 약 케어 여부 (0:미사용, 1:사용)
    breakfastMedicine: null, // 조식 약 복용 (0:복용없음, 1:식전 2:식후)
    lunchMedicine: null,  // 중식 약 복용 (0:복용없음, 1:식전 2:식후)
    dinnerMedicine: null, // 석식 약 복용 (0:복용없음, 1:식전 2:식후)
    beforeBedMedicine: null, // 취짐전 약 복용 (0:복용없음, 1:취짐전)
    medicineInfo: null,   // 약 정보
    emerContactName: '',  // 비상 연락처 이름
    emerContactPhone: '',  // 비상 연락처 전화번호
    bankName: '',         // 거래 은행 이름
    bankAccount: '',      // 거래 은행 계좌
    info: '',             // information
    admissionDate: '',    // 입원일
    grade: null,          // 등급 (0:guest 1:member 50:manager 100:system admin) - only manager supported.
    loginId: '',          // 로그인 ID
  }) => {
    // 필수 필드 확인
    if (!userData.id) {
      throw new Error('사용자 ID는 필수 입력 항목입니다.');
    }

    // 요청 데이터 준비
    const requestData = {
      id: userData.id
    };

    // 선택적 필드들 추가
    const optionalFields = [
      'name', 'nickname', 'birth', 'gender', 'email', 'mobile',
      'hospitalId', 'roomInfo', 'floor', 'careGrade', 
      'isWaterCare', 'isMedicineCare',
      'breakfastMedicine', 'lunchMedicine', 'dinnerMedicine', 'beforeBedMedicine', 'medicineInfo',
      'emerContactName', 'emerContactPhone',
      'bankName', 'bankAccount', 'info', 
      'admissionDate', 'dischargeDate',
      'grade', 'loginId'
    ];

    optionalFields.forEach(field => {
      if (userData[field] !== undefined) {
        // dischargeDate, roomInfo, admissionDate는 빈 문자열이나 null 값도 허용
        if (field === 'dischargeDate' || field === 'roomInfo' || field === 'admissionDate') {
          requestData[field] = userData[field];
        } else if (userData[field] !== '') {
          requestData[field] = userData[field];
        }
      }
    });

    return await fetchAPI('/user', {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData)
    });
  },

  // 유저 가입
  registerUser: async (userData = {
    loginId: '',            // login id
    loginPwd: '',           // user login password
    snsType: null,          // sns type (kakao, naver, google, apple)
    snsId: null,             // sns id
    grade: 0,              // grade (0:guest 1:member 50:manager 100:system admin) default 0
    name: '',              // name
    nickname: '',          // nickname
    birth: '',             // birth day
    gender: null,          // gender (0:male, 1:female)
    email: '',             // e-mail
    mobile: '',            // 휴대전화
    hospitalId: null,      // 병원 아이디
    roomInfo: '',          // 방 정보
    careGrade: '',        // 케어 등급 (0:none, 1(1level) ~ 100(100level))
    isWaterCare: 0,        // 물 케어 여부 (0:미사용, 1:사용)
    isMedicineCare: 0,     // 약 케어 여부 (0:미사용, 1:사용)
    breakfastMedicine: 0,  // 조식 약 복용 (0:복용없음, 1:식전 2:식후)
    lunchMedicine: 0,      // 중식 약 복용 (0:복용없음, 1:식전 2:식후)
    dinnerMedicine: 0,     // 석식 약 복용 (0:복용없음, 1:식전 2:식후)
    beforeBedMedicine: 0,  // 취짐전 약 복용 (0:복용없음, 1:취짐전)
    medicineInfo: 0,      // 약 정보
    emerContactName: '',  // 비상 연락처 이름
    emerContactPhone: '',  // 비상 연락처 전화번호
    bankName: '',         // 거래 은행 이름
    bankAccount: '',      // 거래 은행 계좌 
    info: '',             // information
    admissionDate: '',    // 입원일
    dischargeDate: '',    // 퇴원일
  }) => {

    // 요청 데이터 준비
    const requestData = {
      ...userData,
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET
    };

    return await fetchAPI('/user/register', {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData)
    });
  },

  // 유저 탈퇴 (관리자 전용)
  unregisterUser: async (unregisterData = {
    type: 1,           // 탈퇴 유형 (1:delete, 2:block)
    userId: undefined  // 탈퇴할 사용자 ID (미지정시 자기 자신)
  }) => {
    // 유형 검증
    if (![1, 2].includes(unregisterData.type)) {
      throw new Error('유효하지 않은 탈퇴 유형입니다. (1:delete, 2:block)');
    }

    // 요청 데이터 준비
    const requestData = {
      type: unregisterData.type
    };

    // userId가 지정된 경우에만 포함
    if (unregisterData.userId !== undefined) {
      requestData.userId = unregisterData.userId;
    }

    return await fetchAPI('/user/unregister', {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData)
    });
  },

  // 유저 패스워드 리셋
  resetPassword: async (resetData = {
    loginId: undefined,      // the user login id.
    newPassword: ''        // new login password
  }) => {
    // 필수 필드 확인
    if (!resetData.loginId || !resetData.newPassword) {
      throw new Error('사용자 ID와 새 비밀번호는 필수 입력 항목입니다.');
    }

    return await fetchAPI('/user/reset-password', {
      method: 'POST',
      headers,
      body: JSON.stringify(resetData)
    });
  },

  // 유저 패스워드 인증
  certifyPassword: async (certifyData = {
    userId: undefined,  // 사용자 ID (미지정시 자기 자신)
    password: ''       // 인증할 비밀번호 (필수)
  }) => {
    // 비밀번호 필수 체크
    if (!certifyData.password) {
      throw new Error('비밀번호는 필수 입력 항목입니다.');
    }

    // 요청 데이터 준비
    const requestData = {
      password: certifyData.password
    };

    // userId가 지정된 경우에만 포함
    if (certifyData.userId !== undefined) {
      requestData.userId = certifyData.userId;
    }

    return await fetchAPI('/user/certify-password', {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData)
    });
  },

  // 유저 패스워드 변경
  changePassword: async (passwordData = {
    loginId: undefined,      // the user login id.
    currentPassword: '',    // current login password
    newPassword: ''        // new login password
  }) => {
    // 필수 필드 확인
    if (!passwordData.loginId || !passwordData.currentPassword || !passwordData.newPassword) {
      throw new Error('현재 비밀번호와 새 비밀번호는 필수 입력 항목입니다.');
    }

    // 동일한 비밀번호 체크
    if (passwordData.currentPassword === passwordData.newPassword) {
      throw new Error('새 비밀번호는 현재 비밀번호와 달라야 합니다.');
    }

    // 요청 데이터 준비
    const requestData = {
      loginId: passwordData.loginId,
      currentPassword: passwordData.currentPassword,
      newPassword: passwordData.newPassword,
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET
    };

    // userId가 지정된 경우에만 포함
    if (passwordData.loginId !== undefined) {
      requestData.loginId = passwordData.loginId;
    }

    return await fetchAPI('/user/change-password', {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData)
    });
  },

  // 업로드 프로파일 이미지 (파일 보내지 않으면 삭제)
  uploadProfileImage: async (uploadData = {
    userId: undefined,  // the user id. if not defined, self target.
    file: null         // profile iamge file (keep in last order.)
  }) => {
    // FormData 객체 생성
    const formData = new FormData();

    // userId가 지정된 경우에만 포함
    if (uploadData.userId !== undefined) {
      formData.append('userId', uploadData.userId);
    }

    // 파일 체크
    if (uploadData.file) {      
      // 파일 타입 검증
      const validImageTypes = ['image/png', 'image/jpg', 'image/jpeg'];
      if (!validImageTypes.includes(uploadData.file.type)) {
        throw new Error('지원하지 않는 이미지 형식입니다. (png, jpg, jpeg만 가능)');
      }else{
        formData.append('file', uploadData.file);
      }
    }   

    return await fetchAPI('/user/upload-profile-image', {
      method: 'POST',      
      body: formData
    }, {
      // FormData를 사용하므로 Content-Type 헤더는 자동으로 설정됨
      // Authorization 헤더만 유지
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    });
  }
};